import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import * as React from "react";
import { HHERAllyHeader } from "./HHERAllyHeader";

interface SectionSuggestionPopupProps {
  isOpen: boolean;
  onOk: () => void;
}

function SectionSuggestionPopup({ isOpen, onOk }: SectionSuggestionPopupProps) {
  return (
    <Modal isOpen={isOpen} onClose={onOk} isCentered>
      <ModalOverlay />
      <ModalContent
        width="400px"
        maxWidth="400px"
        height="210px"
        backgroundColor="#F7F7F7"
        borderRadius="14px"
        overflow="hidden"
        boxShadow="0px 4px 3.5px rgba(0, 0, 0, 0.25)"
      >
        <HHERAllyHeader variant="plain" />
        <ModalBody padding="0" position="relative">
          <Text
            position="absolute"
            top="31px"
            left="20px"
            width="360px"
            textAlign="center"
            fontSize="17px"
            lineHeight="21px"
            color="#000000"
          >
            You have suggestions in this section that have not been reviewed.
          </Text>
          <Button
            position="absolute"
            top="101px"
            left="20px"
            width="360px"
            height="50px"
            borderRadius="40px"
            backgroundColor="#007AFF"
            color="white"
            fontSize="17px"
            fontWeight={500}
            onClick={onOk}
            _hover={{ backgroundColor: "#0069D9" }}
            _active={{ backgroundColor: "#0059B8" }}
          >
            OK
          </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export { SectionSuggestionPopup };
export type { SectionSuggestionPopupProps };
